module.exports = __webpack_public_path__ + "static/img/40002 (2).23371d8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40002 (2).webp
// module id = 1OCS
// module chunks = 14